import React from 'react';
import './Programs.css';

const PROGRAMS = [
  {
    title: 'In-person intensives',
    description:
      'Single-day or multi-week workshops built with partner schools. We bring mentors, curriculum, and practical essay and FAFSA support directly into classrooms.',
    bullets: [
      'Application strategy and school list building',
      'Resume shaping and interview prep',
      'Financial-aid walkthroughs with real forms',
      'Family touchpoints and counselor briefings',
    ],
    stats: ['30 to 90 minute sessions', '715 students served through 12 events this year'],
    image: '/images/generalimg/home_page_row/inperson.webp',
    ctaLabel: 'Start a school partnership',
    ctaLink: 'mailto:staff@projectlevelthefield.com',
  },
  {
    title: 'Remote mentorship',
    description:
      'Students are paired with university mentors for weekly coaching. Each cohort receives tailored academic support, essay review, and career planning.',
    bullets: [
      'Goal-setting and progress tracking dashboards',
      'SAT/ACT prep pods and writing studios',
      'Scholarship applications and recommendation strategy',
    ],
    stats: ['2 to 3 month engagements', '129 mentees across 29 cities and 6 states'],
    image: '/images/generalimg/home_page_row/remotementorship.webp',
    ctaLabel: 'Request remote support',
    ctaLink: 'mailto:staff@projectlevelthefield.com',
  },
];

const Programs = () => (
  <div className="programs-page">
    <div className="programs-wrap">

      <header className="programs-hero">
        <p className="programs-eyebrow">Programs</p>
        <h1>Designed to meet students where they are.</h1>
        <p className="programs-hero__sub">
          We offer on-campus intensives and remote mentorship so schools can choose the format
          that fits their students. Every experience is free and led by trained university mentors.
        </p>
      </header>

      <div className="programs-list">
        {PROGRAMS.map((program, index) => (
          <article
            key={program.title}
            className={`program-item${index % 2 === 1 ? ' program-item--flip' : ''}`}
          >
            <div className="program-item__image">
              <img src={program.image} alt={program.title} loading="lazy" decoding="async" />
            </div>
            <div className="program-item__content">
              <h2>{program.title}</h2>
              <p className="program-item__desc">{program.description}</p>
              <ul className="program-item__points">
                {program.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="program-item__stats">
                {program.stats.map((stat, i) => (
                  <span key={stat}>
                    {i > 0 && <span className="program-item__stats-sep" aria-hidden="true" />}
                    {stat}
                  </span>
                ))}
              </div>
              <a href={program.ctaLink} className="program-item__cta">
                {program.ctaLabel}
              </a>
            </div>
          </article>
        ))}
      </div>

      <footer className="programs-footer">
        <p>Not sure which format is the right fit?</p>
        <a href="mailto:staff@projectlevelthefield.com">Talk with our team →</a>
      </footer>

    </div>
  </div>
);

export default Programs;
